import toastr from 'toastr'
import { PaymentService } from '@services/payment'

export default {
  namespaced: true,
  state: {
    cardProcessingFeeConfiguration: '',
    userPaymentMethods: {}
  },
  mutations: {
    setCardProcessingFeeConfiguration (state, value) {
      state.cardProcessingFeeConfiguration = value
    },
    setUserPaymentMethods (state, value) {
      state.userPaymentMethods = value
    }
  },
  actions: {
    async setCardProcessingFeeConfiguration (_context, data) {
      await PaymentService.getProcessingFeeConfiguration(data.currencyCode)
        .then((data) => {
          _context.commit('setCardProcessingFeeConfiguration', data)
        })
        .catch((error) => {
          toastr.error(error)
        })
    },
    async acknowledgeCreditCardProcessingFee (_context, cardTypeId) {
      await PaymentService.acknowledgeProcessingFee(cardTypeId)
        .then((data) => {
          return true
        })
        .catch((error) => {
          toastr.error(error)
        })
    },
    async getUserPaymentMethods (_context) {
      await PaymentService.getUserPaymentMethods()
        .then((data) => {
          _context.commit('setUserPaymentMethods', data)
        })
        .catch((error) => {
          toastr.error(error)
        })
    }
  },
  getters: {
    cardProcessingFeeConfiguration: state => state.cardProcessingFeeConfiguration,
    userPaymentMethods: state => state.userPaymentMethods
  }
}
